export enum LineHeight {
    Micro = 'micro',
    Small = 'small',
    Normal = 'normal',
    SemiMedium = 'semiMedium',
    Medium = 'medium',
    Large = 'large',
    ExtraLarge = 'extraLarge',
}
